import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {RolePermissionsPage} from "./-page/role-permissions.page";
import {RolePermissionsPending} from "./-page/role-permissions.pending";

export const Route = createFileRoute("/_app/user-management/users/roles/$roleId/permissions/")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  pendingComponent: RolePermissionsPending,
});

function RouteComponent() {
  const {roleId} = Route.useParams();

  return <RolePermissionsPage key={roleId} roleId={roleId} />;
}
